import { types } from "mobx-state-tree";
import { BaseEntity, DictionaryItem } from "modules/common/models/entity";
import { EMPTY_OBJECT_ID, DATE_TIME_FORMAT } from "modules/common/constants";
import Schema from "../components/details/validation";
import moment from "moment";
import { nameof } from "modules/common/services/typescript";
import { getFieldLabel } from "modules/common/services/form/fields";

export const DepartmentDictionaryItem = types
    .compose(
        DictionaryItem,
        types.model({
            order: types.maybeNull(types.number),
            // родитель в дереве структуры: подписи «путь / отдел» в выпадающих списках
            parentId: types.maybeNull(types.string),
        })
    )
    .named("DepartmentDictionaryItem");

/**
 * Отдел — образец модели сущности по правилу из Rost.Ui/CLAUDE.md («Модели MST:
 * сущность, список, карточка»).
 *
 * Модель — только данные, id — types.identifier: один узел = один отдел навсегда.
 * Загрузка, сохранение и удаление живут в сторе (departments-store.ts): карточка
 * там — сменяемое поле, при открытии другого отдела узел заменяется целиком, а не
 * перезаливается чужими данными. Поэтому менять id у существующего узла не
 * приходится, и MST это разрешает.
 */
export const Department = types
    .compose(
        BaseEntity,
        types.model({
            id: types.identifier,
            name: types.string,
            description: types.string,
            order: types.maybeNull(types.number),
        })
    )
    .named("Department");

export type DepartmentDictionaryItemType = typeof DepartmentDictionaryItem.Type;
export type DepartmentSnapshotType = typeof Department.SnapshotType;
export type DepartmentType = typeof Department.Type;

export const initialState = (): DepartmentSnapshotType => ({
    id: EMPTY_OBJECT_ID,
    created: moment().format(DATE_TIME_FORMAT),
    name: "",
    description: "",
    order: null,
});

export const fields = {
    name: nameof((a: DepartmentType) => a.name) as string,
    description: nameof((a: DepartmentType) => a.description) as string,
    order: nameof((a: DepartmentType) => a.order) as string,
};

export function formatDepartment(stage: DepartmentSnapshotType | null) {
    let result = "";

    if (stage) {
        const schema = Schema();

        result += `${getFieldLabel(fields.name, schema, null)}: ${stage.name}\n`;
        result += `${getFieldLabel(fields.description, schema, null)}: ${stage.description}\n`;
    }

    return result;
}
